import "@/components/report/iframeDetectForPv"
import "mptcfe-spm/dist/js/index"
import "./sass/main_article.less"
import LazyLoad from "@/components/lazyload"
import { getUserInfo } from '@/request/request'
window.$ = require('jquery')
window._ = require('underscore')
// 懒加载&图片解密
import { initImg, getArticleImg } from "@/utils/crypto"
// 文章等级样式处理
import SgradeStyle  from "@/pages/article_main/js/article_sgrade"
import {
    renderHeadRight,
    renderMoreNav,
    renderLogin,
    renderArticleInsert,
    renderMedal,
    renderUserProfile,
    renderRightBtns,
    renderLeftShare,
    handleShowMore,
    renderArticleReport,
    renderReprint,
    renderArticlePv,
    showBannedNotice,
    asyncImportSentry,
    renderSpecialBenefits,
    renderHeadVideo,
    renderMiddleInsertVideo
} from './pages/article_main/js/handleDom'

import "@/utils/eventBus"
import Vue from "vue";
import toast from '../src/plugin/toast'
// 全局挂载toast
Vue.use(toast)
import { bindAriaEvent } from "./utils/bindAria.js";
import articleSGrade from '@/components/articleSGrade'
import { performanceReport } from 'mpfe-utils'
import Report from "@/components/report"
import contentControl from "@/components/contentControl"
import { bindMobile } from "./utils/bindMobile.js"

const article = function (opts) {
    // 来源检测并重置文章模板等级
    opts.sGrade = articleSGrade(opts) ? articleSGrade(opts) : opts.sGrade
    console.log('opts:', opts)
    window.pcArticleInfo = opts

    renderHeadRight()
    renderMoreNav()

    if(opts.displayMode != '2') {
        initImg(opts.imgsList) // 图片解密+占位
        getArticleImg(false) // 图片懒加载
    }

    window.LazyLoadIns = new LazyLoad()
    SgradeStyle(opts) // 根据文章等级调整文章样式
    renderHeadVideo(opts) // 渲染头插视频
    renderMiddleInsertVideo() // 渲染中插视频
    renderSpecialBenefits(opts) // 权益逻辑处理

    // 依赖登录信息的区块渲染
    getUserInfo()
        .then((res) => {
            if (res?.code == 1 && res?.data) {
                window.userInfo = res?.data
            }
        })
        .catch((error) => {
            console.log('获取用户信息失败', error)
        })
        .finally(() => {
            renderLogin() // 渲染登录
            renderArticleInsert() // 正文插入功能卡&推荐卡
        })
    renderMedal() // 积分勋章
    renderUserProfile() // 左侧作者卡片
    renderRightBtns() //右侧悬浮按钮
    renderLeftShare() // 左侧分享
    handleShowMore() // 展开更多
    renderArticleReport() //内容举报
    renderReprint() // 转载文章信息
    renderArticlePv() // 文章页阅读数
    showBannedNotice() // 评论禁言通知
    bindMobile() // 判断是否需要动态加载登录包,以唤起绑定手机号弹窗

    //添加前端性能上报
    window.onload = function () {
        performanceReport()
        bindAriaEvent()
        Report(opts)
        // 异步加载sentry
        // asyncImportSentry()
    }
}

try {
    window.RUNNINGENV = RUNNINGENV
    window.sohu_mp = {
        article: article,
        contentControl: contentControl
    }
} catch (e) {
    console.log("初始化代码错误",e);
}


